var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('b-jumbotron',{staticClass:"mt-4",scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("Istoric tranzacții")]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }